import React from 'react';

import { getTimeFromString } from '../../../../../../common/utils/format';

import './RouteSchemaItem.css';

function renderBeforeTxt(routes, number, first, last) {
  if (number === routes.indexOf(first)) {
    return 'Посадка';
  }
  if (number === routes.indexOf(last)) {
    return 'Высадка';
  }
  if (number > routes.indexOf(first) && number < routes.indexOf(last)) {
    return `Остановка ${number}`;
  }
}

function renderAfterTxt(routes, number, first, last) {
  if (number === routes.indexOf(first)) {
    return 'Место подачи ТС';
  }
  if (number === routes.indexOf(last)) {
    return 'Конечный пункт';
  }
  if (number > routes.indexOf(first) && number < routes.indexOf(last)) {
    return `Промежуточный пункт ${number}`;
  }
}

const RouteSchemaItem = ({
  number,
  routes,
  address,
  waiting,
  first,
  last,
  distance,
  duration,
}) => {
  return (
    <li className="schemaItemContainer">
      <div className="schemaItem">
        <span className="before">
          <span className="over">
            {renderBeforeTxt(routes, number, first, last)}
          </span>
          <span className="main">{getTimeFromString(waiting)}</span>
        </span>
        <span className="dot">{number + 1}</span>
        <span className="line" />
        <span className="after">
          <span className="over">
            {renderAfterTxt(routes, number, first, last)}
          </span>
          <span className="main">{address}</span>
        </span>
      </div>
      {number !== routes.indexOf(last) && (
        <span className="info">
          <span>{duration}</span>
          <span className="line" />
          <span>{distance}</span>
        </span>
      )}
    </li>
  );
};

export default RouteSchemaItem;
